import React, { useState } from "react";
import { Image, ImageProps, Button, Icon, Modal } from "semantic-ui-react";
import { useFileUrl } from "../context/FileUploadContext";


const PUBLIC_PATH = process.env.PUBLIC_URL;


interface IImageProps extends ImageProps {
    id: string;
    noModal?: boolean;
};

export const ImageView: React.FC<IImageProps> = ({ id, noModal = false, ...imgProps }) => {
    const { loadError, fileUrl } = useFileUrl(id);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    if (fileUrl) {
        if (noModal) {
            return <Image  {...imgProps} src={fileUrl} alt={id} />;
        };
        return (
            <Modal
                open={isModalOpen}
                trigger={<Image   {...imgProps} src={fileUrl} />}
                onOpen={openModal}
                onClose={closeModal}
            >
                <Modal.Content style={{ minHeight: "500px", display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <div> <Image src={fileUrl} alt={id} />  </div>
                </Modal.Content>
                <Modal.Actions style={{ marginBottom: "70px" }}>
                    <Button onClick={closeModal} negative style={{ width: "100%", marginLeft: 0 }}> Sulje </Button>
                </Modal.Actions>
            </Modal >
        );
    };


    if (loadError) {
        const style = {
            height: 90,
            width: 120,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0,0,0,0.1)"
        };
        return (
            <a className={imgProps.className} style={style}>
                <Icon name="ban" size="large" color="grey" />
            </a>
        );
    };

    return <Image {...imgProps} src={PUBLIC_PATH + "/loading_placeholder.gif"} />;
};
